import GameScene from '../../Components/GameScene/GameScene'

class GameSceneContainer {
    element = document.querySelector('#game-scene-container') as HTMLDivElement
    gameSceneContainer = this.element.querySelector('#game-scenes') as HTMLDivElement

    show = () => {
        this.element.classList.remove('hidden')
        // TODO: Inventory.show() ?
    }

    hide = () => {
        this.element.classList.add('hidden')
        // TODO: Inventory.hide() ?
    }

    addScene = (gameScene: GameScene) => {
        this.gameSceneContainer.appendChild(gameScene.element)
    }

    removeScene = (gameScene: GameScene) => {
        this.gameSceneContainer.removeChild(gameScene.element)
    }

    addClassName = (className: string) => {
        this.element.classList.add(className)
    }

    removeClassName = (className: string) => {
        this.element.classList.remove(className)
    }
}

export default new GameSceneContainer()
